<template>
  <section>
    <nav-top />
    <div class="container-fluid">
      <div class="row flex-xl-nowrap">
        <main class="p-3 col-12" role="main">
          <slot />
        </main>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import NavTop from './NavTop'
export default {
  name: 'authenticated-layout',
  components: {
    NavTop,
  },
  mounted() {
    if (!this.isAuth) {
      this.logout()
    }
  },
  computed: {
    ...mapGetters('users', ['token']),
    isAuth() {
      let _is = false
      if (this.token !== null) {
        if (this.token !== '') {
          _is = true
        }
      }
      return _is
    },
  },
  methods: {
    ...mapActions('users', ['setLogout']),
    logout() {
      this.setLogout()
      this.$inertia.post('logout')
    },
  },
}
</script>
<style lang="scss" scoped>
</style>
